<template>
  <el-aside width="200px">
    <!--课程管理人员roleID ==2 -->
    <el-menu
    :default-active="activeIndex"
    @open="handleOpen"
    @close="handleClose"
    @select="handleSelect"
    background-color="#fff"
    text-color="#999"
    active-text-color="#67C23A" v-if="roleId == 2">
    <h3 id="logo"><i class="el-icon-setting"></i>后台管理</h3>
    <el-menu-item index="1">
      <router-link to="/Product"><i class="el-icon-menu"></i>
        <span>课程管理</span>
      </router-link>
    </el-menu-item>

    <el-button type="text" class="out" @click="webBack()">退出</el-button>
  </el-menu>
    <!--答疑用户 -->
    <el-menu
      :default-active="activeIndex"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
      background-color="#fff"
      text-color="#999"
      active-text-color="#67C23A" v-else-if="roleId == 3">
      <h3 id="logo"><i class="el-icon-setting"></i>后台管理</h3>
      <el-menu-item index="7">
        <router-link to="/stayWord">
          <i class="el-icon-edit"></i>
          <span>留言管理</span></router-link>
      </el-menu-item>

      <el-button type="text" class="out" @click="webBack()">退出</el-button>
    </el-menu>

    <el-menu
      style="height: 135%"
      :default-active="activeIndex"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
      background-color="#fff"
      text-color="#999"
      active-text-color="#67C23A" v-else>
      <h3 id="logo"><i class="el-icon-setting"></i>后台管理</h3>
      <el-menu-item index="1">
        <router-link to="/Product"><i class="el-icon-menu"></i>
          <span>课程管理</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="2">
        <router-link to="/Banner">
          <i class="el-icon-picture"></i>
          <span>轮播管理</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="3">
        <router-link to="/System">
          <i class="el-icon-setting"></i>
          <span>系统图片</span></router-link>
      </el-menu-item>
      <el-menu-item index="4">
        <router-link to="/conponPage">
          <i class="el-icon-tickets"></i>
          <span>优惠券</span></router-link>
      </el-menu-item>
      <el-menu-item index="5">
        <router-link to="/tip">
          <i class="el-icon-bell"></i>
          <span>消息提示</span></router-link>
      </el-menu-item>
      <el-menu-item index="6">
        <router-link to="/manage">
          <i class="el-icon-goods"></i>
          <span>优惠券管理</span></router-link>
      </el-menu-item>
      <el-menu-item index="11">
        <router-link to="/notice">
          <i class="el-icon-goods"></i>
          <span>通告管理</span></router-link>
      </el-menu-item>
      <el-menu-item index="7">
        <router-link to="/stayWord">
          <i class="el-icon-edit"></i>
          <span>留言管理</span></router-link>
      </el-menu-item>
      <el-menu-item index="8">
        <router-link to="/playCard">
          <i class="el-icon-date"></i>
          <span>打卡管理</span></router-link>
      </el-menu-item>
      <el-menu-item index="9">
        <router-link to="/classifyPage">
          <i class="el-icon-guide"></i>
          <span>课程分类</span></router-link>
      </el-menu-item>
      <el-menu-item index="10">
        <router-link to="/QuesPage">
          <i class="el-icon-question"></i>
          <span>答疑区</span></router-link>
      </el-menu-item>
      <el-menu-item index="12">
        <router-link to="/Dynamic">
          <i class="el-icon-printer"></i>
          <span>学习圈</span></router-link>
      </el-menu-item>
      <el-menu-item index="13">
        <router-link to="/Topic">
          <i class="el-icon-printer"></i>
          <span>话题管理</span></router-link>
      </el-menu-item>
      <el-menu-item index="14">
        <router-link to="/TopicCategory">
          <i class="el-icon-printer"></i>
          <span>话题分类管理</span></router-link>
      </el-menu-item>
      <el-button type="text" class="out" @click="webBack()">退出</el-button>
    </el-menu>
  </el-aside>

</template>
<style>
  .out {
    width: 100%;
    position: absolute;
    bottom: 15px;
    color: #67C23A;
  }

  .out:hover {
    color: #67C23A;
  }

  .el-menu a {
    display: block;
  }
</style>

<script>

  export default {
    data() {
      return {
        roleId : 1
      };
    },
    props: [
      'activeIndex'
    ],
    mounted() {
      let roleId = localStorage.getItem('roleId');
      if(roleId == 2){
        this.roleId = 2
      }else if(roleId == 3){
          this.roleId = 3
      }
    },
    methods: {
      handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        //console.log(key, keyPath);
      },
      handleSelect(key, keyPath) {
        //console.log(key, keyPath);
      },
      webBack: function () {
        var that = this;
        that.$message({
          message: "退出成功",
          type: "success"
        });
        that.$router.push({
          path: '/'
        })
      }
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/Navmenu.vue



// WEBPACK FOOTER //
// src/components/meun.vue